
import { Vue, Component, Prop } from "vue-property-decorator";
import * as InboxStore from "../store/modules/inbox";
import { LANGUAGE_OPTIONS } from "../core/messages";
import Snack from "../utils/snack";
import Devices, { Device } from "../core/devices";

@Component({})
export default class Settings extends Vue {
  // Props
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  // Data
  languageOptions = LANGUAGE_OPTIONS;
  isFormValid = false;
  validationRules = {
    userId: [(v: string) => !!v || "Required"],
    deviceId: [(v: string) => !!v || "Required"],
    fcmToken: [(v: string) => !!v || "Required"],
    roonProduct: [(v: string) => !!v || "Required"],
    roonVersion: [(v: string) => !!v || "Required"],
    roonPlatform: [(v: string) => !!v || "Required"]
  };

  // Computed
  get userId(): string {
    return InboxStore.getters.userId;
  }
  set userId(id: string) {
    InboxStore.mutations.setUserId(id);
  }
  get deviceId() {
    return InboxStore.getters.deviceId;
  }
  set deviceId(id) {
    InboxStore.mutations.setDeviceId(id);
  }
  get fcmToken() {
    return InboxStore.getters.fcmToken;
  }
  get roonVersion() {
    return InboxStore.getters.roonVersion;
  }
  set roonVersion(version) {
    InboxStore.mutations.setRoonVersion(version);
  }
  get roonProduct() {
    return InboxStore.getters.roonProduct;
  }
  set roonProduct(product) {
    InboxStore.mutations.setRoonProduct(product);
  }
  get roonPlatform() {
    return InboxStore.getters.roonPlatform;
  }
  set roonPlatform(platform) {
    InboxStore.mutations.setRoonPlatform(platform);
  }

  get language() {
    return InboxStore.getters.language;
  }
  set language(lang: string) {
    InboxStore.mutations.setLanguage(lang);
  }

  get isVisible() {
    return this.show;
  }
  set isVisible(visible: boolean) {
    if (visible) {
      return;
    }

    if (this.userId) {
      this.$emit("close");
    }
  }
  // Methods
  async registerDevice() {
    if (!this.isFormValid) {
      return;
    }

    const device: Device = {
      id: this.deviceId,
      token: this.fcmToken,
      userId: this.userId,
      roonPlatform: this.roonPlatform,
      roonVersion: this.roonVersion,
      roonProduct: this.roonProduct,
      language: this.language
    };

    try {
      await Devices.registerDevice(device);
      Snack.success("Device registered successfully");
      this.isVisible = false;
    } catch (err) {
      Snack.error(`Error registering device:<br>${err}`);
    }
  }
  // Life-cycle hooks
}
